import React from 'react';
import FilterBarContainer from '../ProfDashFilterBarContainer';
import styles from './ProfessorDashboard.module.css';

function FilterSidebar({ onFilterChange }) {
  return (
    <div className={styles.filterSidebar}>
      <FilterBarContainer onFilterChange={onFilterChange} />
    </div>
  );
}

export default FilterSidebar;